<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="col-lg-12 mb-4">

            <ValidationObserver ref="form">
                <div class="box">
                    <div class="box-offset">
                        <div class="box-ttl-wrap">
                            <div class="box-ttl">New Schedule</div>
                        </div>
                        <div class="form mt-3">
                            <div class="row">
                                <ValidationProvider
                                    name="Location"
                                    rules="required"
                                    v-slot="{ errors }"
                                    class="col-md-12"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Property Name</label>
                                        <select
                                            class="custom-select"
                                            v-model="shift.client_id"
                                        >
                                            <option
                                                v-for="client in clientsList"
                                                :key="client.id"
                                                :value="client.id"
                                            >
                                                {{ client.name }}
                                            </option>
                                        </select>
                                        <FormError :error="errors[0]" name="Location"></FormError>
                                    </div>
                                </ValidationProvider>
                                <div class="col-lg-12">
                                    <div class="table-holder table-responsive ">
                                        <table class="table shifts-table">
                                            <thead>
                                            <tr>
                                                <th>Shift/Days</th>
                                                <th>Mon</th>
                                                <th>Tue</th>
                                                <th>Wed</th>
                                                <th>Thu</th>
                                                <th>Fri</th>
                                                <th>Sat</th>
                                                <th>Sun</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Morning</td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input
                                                                class="form-check-input-checkbox"
                                                                type="checkbox"
                                                                name="morning"
                                                                value="1st"
                                                                id="mon-mor"
                                                                v-model="shift.schedule.monday">
                                                            <label class="form-check-label" for="mon-mor"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   name="morning"
                                                                   value="1st"
                                                                   id="tue-mor"
                                                                   v-model="shift.schedule.tuesday">
                                                            <label class="form-check-label" for="tue-mor"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   name="morning"
                                                                   value="1st"
                                                                   id="wed-mor"
                                                                   v-model="shift.schedule.wednesday">
                                                            <label class="form-check-label" for="wed-mor"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="1st"
                                                                   name="morning"
                                                                   id="thu-mor"
                                                                   v-model="shift.schedule.thursday">
                                                            <label class="form-check-label" for="thu-mor"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="1st"
                                                                   name="morning"
                                                                   id="fri-mor"
                                                                   v-model="shift.schedule.friday">
                                                            <label class="form-check-label" for="fri-mor"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="1st"
                                                                   name="morning"
                                                                   id="sat-mor"
                                                                   v-model="shift.schedule.saturday">
                                                            <label class="form-check-label" for="sat-mor"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="1st"
                                                                   name="morning"
                                                                   id="sun-mor"
                                                                   v-model="shift.schedule.sunday">
                                                            <label class="form-check-label" for="sun-mor"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Afternoon</td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="2nd"
                                                                   name="afternoon"
                                                                   id="aft-mon"
                                                                   v-model="shift.schedule.monday">
                                                            <label class="form-check-label" for="aft-mon"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="2nd"
                                                                   name="afternoon"
                                                                   id="aft-tue"
                                                                   v-model="shift.schedule.tuesday">
                                                            <label class="form-check-label" for="aft-tue"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="2nd"
                                                                   name="afternoon"
                                                                   id="aft-wed"
                                                                   v-model="shift.schedule.wednesday">
                                                            <label class="form-check-label" for="aft-wed"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="2nd"
                                                                   name="afternoon"
                                                                   id="aft-thu"
                                                                   v-model="shift.schedule.thursday">
                                                            <label class="form-check-label" for="aft-thu"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="2nd"
                                                                   name="afternoon"
                                                                   id="aft-fri"
                                                                   v-model="shift.schedule.friday">
                                                            <label class="form-check-label" for="aft-fri"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="2nd"
                                                                   name="afternoon"
                                                                   id="aft-sat"
                                                                   v-model="shift.schedule.saturday">
                                                            <label class="form-check-label" for="aft-sat"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="2nd"
                                                                   name="afternoon"
                                                                   id="aft-sun"
                                                                   v-model="shift.schedule.sunday">
                                                            <label class="form-check-label" for="aft-sun"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Night</td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="3rd"
                                                                   name="night"
                                                                   id="night-mon"
                                                                   v-model="shift.schedule.monday">
                                                            <label class="form-check-label" for="night-mon"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="3rd"
                                                                   name="night"
                                                                   id="night-tue"
                                                                   v-model="shift.schedule.tuesday">
                                                            <label class="form-check-label" for="night-tue"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="3rd"
                                                                   name="night"
                                                                   id="night-wed"
                                                                   v-model="shift.schedule.wednesday">
                                                            <label class="form-check-label" for="night-wed"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="3rd"
                                                                   name="night"
                                                                   id="night-thu"
                                                                   v-model="shift.schedule.thursday">
                                                            <label class="form-check-label" for="night-thu"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="3rd"
                                                                   name="night"
                                                                   id="night-fri"
                                                                   v-model="shift.schedule.friday">
                                                            <label class="form-check-label" for="night-fri"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="3rd"
                                                                   name="night"
                                                                   id="night-sat"
                                                                   v-model="shift.schedule.saturday">
                                                            <label class="form-check-label" for="night-sat"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group form-group-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input-checkbox" type="checkbox"
                                                                   value="3rd"
                                                                   name="night"
                                                                   id="night-sun"
                                                                   v-model="shift.schedule.sunday">
                                                            <label class="form-check-label" for="night-sun"></label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Notes</label>
                                        <textarea
                                            type="text"
                                            class="form-control height-2"
                                            v-model="shift.note"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="wrap-border-top"></div>
                            <div class="row">
                                <ValidationProvider
                                    class="col-md-6"
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Position"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Position </label>
                                        <select
                                            class="custom-select"
                                            v-model="shift.position_id"
                                        >
                                            <option
                                                v-for="position in positions"
                                                :key="position.id"
                                                :value="position.id"
                                                :selected="shift.position_id"
                                            >
                                                {{ position.title }}
                                            </option>
                                        </select>
                                        <FormError :error="errors[0]" name="Position"></FormError>
                                    </div>
                                </ValidationProvider>
                                <div class="col-md-6">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Specific Schedule </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="shift.specific_schedule">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Additional Information</label>
                                        <textarea
                                            type="text"
                                            class="form-control height-2"
                                            v-model="shift.training_information"
                                        ></textarea>
                                    </div>
                                </div>

                                <ValidationProvider
                                    class="col-md-6"
                                    name="Pay Range"
                                    v-slot="{ errors }"
                                    rules="required"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Pay Range </label>
                                        <input type="text" class="form-control" v-model="shift.pay_range">
                                        <FormError :error="errors[0]" name="Pay Range"></FormError>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    class="col-md-6"
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Priority"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Priority</label>
                                        <select class="custom-select" v-model="shift.priority">
                                            <option value="low">Low</option>
                                            <option value="medium">Medium</option>
                                            <option value="high">High</option>
                                        </select>
                                        <FormError :error="errors[0]"  name="Priority"></FormError>
                                    </div>
                                </ValidationProvider>
                                <div class="col-md-12">
                                    <div class="form-group form-group-1 d-flex align-items-center">
                                        <div class="mr-2">Active Status</div>
                                        <VueToggles
                                            height="30"
                                            width="80"
                                            font-size="14"
                                            checkedBg="#60ad45"
                                            uncheckedBg="#e0e1e2"
                                            :value="Boolean(shift.status)"
                                            @click="changeStatus()"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="btns-wrap">
                                        <a href="/master-admin/shift-board"
                                           class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                                        <a class="btn btn--secondary w-100 w-sm-auto" @click="validateForm">Proceed</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>


<script>
import ShiftBoardService from "./services/ShiftBoardService";
import CommonService from "../../../AppUser/resources/js/services/CommonService";

export default {
    name: 'ShiftBoardItem',
    props: {
        shiftBoard: {
            type: Object,
        },
        activatingShift: {
            type: Boolean
        }
    },
    data() {
        return {
            loading: true,
            isUpdate: false,
            shiftId: null,
            clientsList: [],
            positions: [],
            shift: {

                client_id: null,
                note: null,
                pay_range: null,
                priority: null,
                position_id: null,
                status: false,
                specific_schedule: null,
                schedule: {
                    monday: [],
                    tuesday: [],
                    wednesday: [],
                    thursday: [],
                    friday: [],
                    saturday: [],
                    sunday: [],
                },
                training_information: null,

            }
        }
    },
    methods: {
        changeStatus() {
            if(!this.activatingShift) {
                this.$showErrorMessage("You do not have access to change status")
                return
            }
            this.shift.status = !this.shift.status
        },
        async getClientsList() {
            try {
                const {data: clients} = await CommonService.getClientsList()
                this.clientsList = clients
            } catch (e) {
                console.error()
                this.$showErrorMessage();
            }
        },
        async getListOfPositions() {
            try {
                const {data: positions} = await CommonService.getListOfPositions()
                this.positions = positions
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async saveShift() {
            this.$showLoadingMessage()
            try {
                await ShiftBoardService.saveNewShift(this.shift)
                this.$showSuccessMessage('New Shift was added!')
                setTimeout(() => {
                    window.location.href = '/master-admin/shift-board'
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage()
            }
        },
        setData(shiftBoard) {
            for (const fullKey in shiftBoard) {
                for (const emptyKey in this.shift) {
                    if (fullKey === emptyKey) {
                        this.shift[fullKey] = shiftBoard[emptyKey];
                    }
                }
            }
            this.loading = false
        },
        async updateExistShift() {
            this.$showLoadingMessage()
            try {
                await ShiftBoardService.updateShift(this.shiftBoard.id, this.shift)
                this.$showSuccessMessage('New Shift was updated!')
                setTimeout(() => {
                    window.location.href = '/master-admin/shift-board'
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage()
            }
        },
        async validateForm() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }

            if (this.isUpdate === false) {
                await this.saveShift()
            } else {
                await this.updateExistShift()
            }
        }
    },
    mounted() {
        const currentPath = window.location.pathname;

        if (currentPath === '/master-admin/shift-board/create') {
            this.isUpdate = false;
            this.loading = false;
        } else {
            this.isUpdate = true
            this.setData(this.shiftBoard);
        }

        this.getClientsList();
        this.getListOfPositions();
    }

}

</script>


<style scoped>

</style>
